import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { AlertasService } from '../core/_services/alerta.service';
import { CoreService } from '../core/_services/core.services';
import { CALENDARIO_ESPANOL } from 'src/app/core/_util/fechas';
import { formatDate } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-ejecutar-consulta',
  templateUrl: './ejecutar-consulta.component.html',
  styleUrls: ['./ejecutar-consulta.component.scss']
})
export class EjecutarConsultaComponent implements OnInit {
  
    @Input () listaConsultas: string;
  
    resultadoConsulta : any;
    consultaActual: any;
  
    listaColumnas : any[];
    listaColumnasFiltrar : any[] = [];
    columnasDisponibles : any [];
    columnasExcluidas : any [] = [];
  
    cargandoDetalle : boolean = true;
    mostrarDetalle : boolean = false;
  
    formBuilder: FormBuilder;
    formulario: FormGroup;

    es = CALENDARIO_ESPANOL;
    
  constructor(
    public coreService: CoreService,
    public msj: AlertasService,
    public spinner: NgxSpinnerService,
  ) { 
    this.formBuilder = new FormBuilder();
  }


  ngOnInit(): void {

  }

  traerColumnas(){
    let data = {
      consulta_id :this.resultadoConsulta
    }
    this.listaColumnasFiltrar = [];
    
    this.coreService.getWithParams('/cabecera-detalle', data).subscribe(
      (res: any[]) => {
        
        let aux = res;
        var data = {};        
        aux.forEach(registro => {
          if(registro['permitir_filtrar'] == 1){
            this.listaColumnasFiltrar.push(registro);
            if(registro['tipo_dato'] == 'DATE'){
              data[registro['columna']] = new FormControl('', [ (registro['solicitar_obligatorio'] == 1) ? Validators.required : Validators.nullValidator ]);
              data['final_'+registro['columna']] = new FormControl('');
            }else if(registro['tipo_presentacion'] == 'DROPDOWN'){
              
              let arreglo = JSON.parse(registro['consulta_datos']);
              registro['consulta_datos'] = arreglo;
              
              data[registro['columna']] = new FormControl([], [ (registro['solicitar_obligatorio'] == 1) ? Validators.required : Validators.nullValidator ]);
            }else{
              data[registro['columna']] = new FormControl([], [ (registro['solicitar_obligatorio'] == 1) ? Validators.required : Validators.nullValidator ]);
            }
          }
        }); 
        
        this.formulario = this.formBuilder.group(data);  
        this.columnasDisponibles = res;
        this.mostrarDetalle = true;
        this.listaColumnas = aux;        

      },
      (err: any) => {
        this.cargandoDetalle = false;
        console.log(err);
      }
    )
  }

  ejecutarConsulta(){
    
    const formato = 'yyyy-MM-dd';
    const localizacion = 'en-US';
    let params = {
      id:this.resultadoConsulta
    }
    if(this.validar()){
      this.spinner.show();
      this.coreService.post('/consultar-cabecera', params).subscribe(
        (res: any[]) => {
          this.consultaActual = res['consulta'];
        },
        (err: any) => {
          this.cargandoDetalle = false;
          console.log(err);
        }
      )
      let aux = [];
      let aux2 = [];
      this.listaColumnasFiltrar.forEach(columna => {
        if((this.formulario.get(columna['columna']).value != '') && (this.formulario.get(columna['columna']).value != null)){
          if(columna['tipo_presentacion'] == 'INPUT' && columna['tipo_dato'] == 'VARCHAR2'){
            aux.push([ columna['columna'].toLowerCase() , 'like' , "%"+this.formulario.get(columna['columna']).value.toUpperCase()+"%"]);
          }
          else if(columna['tipo_presentacion'] == 'DROPDOWN'){
            aux.push([ columna['columna'].toLowerCase() , '=' , this.formulario.get(columna['columna']).value['name']]);
          }
          else if(columna['tipo_presentacion'] == 'INPUT' && columna['tipo_dato'] == 'NUMBER' ){
            aux.push([ columna['columna'].toLowerCase() , '=' , this.formulario.get(columna['columna']).value]);
          }
          else if(columna['tipo_presentacion'] == 'INPUT' && columna['tipo_dato'] == 'DATE' ){
            aux.push([ columna['columna'].toLowerCase() , '>=' , formatDate(this.formulario.get(columna['columna']).value, formato, localizacion)+' 00:00']);
            if(this.formulario.get('final_'+columna['columna']).value != '' && this.formulario.get('final_'+columna['columna']) != null){
              aux.push([ columna['columna'].toLowerCase() , '<=' , formatDate(this.formulario.get('final_'+columna['columna']).value, formato, localizacion)+' 23:59']);
            }else{
              aux.push([ columna['columna'].toLowerCase() , '<=' , formatDate(this.formulario.get(columna['columna']).value, formato, localizacion)+' 23:59']);
            }
          }
          else if(columna['tipo_presentacion'] == 'TEXTAREA'){
            aux.push([ columna['columna'].toLowerCase() , '=' , this.formulario.get(columna['columna']).value.toUpperCase()]);
          }
          else{
            aux.push([columna['columna'].toLowerCase(), '=' , this.formulario.get(columna['columna']).value]);
          }
        }
      });
      this.columnasDisponibles.forEach(columna=> {
        aux2.push(columna['columna'].toLowerCase());
      });
      let data = {
        listaColumnasSelec : aux2,
        datosFiltrar : aux,
        id:this.resultadoConsulta
      }
      
      this.coreService.downloadWithParams('/ejecutar-consulta', data).subscribe(
        (res: any) => {
            if(res.body.type != 'application/json'){

              let blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
              let file = new File([blob], 'prueba.xlsx', { type: res.headers.get('Content-Type'), lastModified: Date.now() });
              var fileURL = URL.createObjectURL(file);
              var today = new Date();
              var dd = today.getDate();
              var mm = today.getMonth() + 1;
              var yyyy = today.getFullYear();
              var hora = today.getHours();
              var minutos = today.getMinutes();
              let titulo = this.consultaActual.titulo.replace(/ /g, "");
              var linkToFile = document.createElement('a');
              linkToFile.download = titulo+'_D_'+dd+'-'+mm+'-'+yyyy+'H_'+hora+'-'+minutos+'.xlsx';
              linkToFile.href = fileURL;
              linkToFile.click();
              this.spinner.hide();
              this.msj.info("Consulta ejecutada exitosamente.");
            } else {
              this.spinner.hide();
              this.msj.error("El archivo no se encontró.");
            }
        },
        (err: any) => {
          this.spinner.hide();
          this.msj.error("No es posible ejecutar la consulta, verifique que el nombre de las columnas sea el correcto.");
        }
      );
    }
  }

  validar(){
    let valido  = true;
    this.listaColumnasFiltrar.forEach(columna => {
      if(columna['solicitar_obligatorio'] == 1){
        if(JSON.stringify(this.formulario.get(columna['columna']).value) === JSON.stringify([])){
          valido = false;
          this.msj.error('Lo sentimos, el campo '+ (columna['etiqueta']) +' es obligatorio.' )
        }
      }
      if(columna['tipo_dato'] == 'DATE'){
        if(this.formulario.get(columna['columna']).value != null && this.formulario.get(columna['columna']).value != '' && this.formulario.get('final_'+columna['columna']).value != '' && this.formulario.get('final_'+columna['columna']).value != null){
          if(this.formulario.get('final_'+columna['columna']).value < this.formulario.get(columna['columna']).value){
            valido = false;
            this.msj.error('Lo sentimos, la fecha inicial en el campo '+ (columna['etiqueta']) +' debe ser menor a la final.' )
          }
        }
      }
    });
    return valido;
  }

}
